export default __webpack_public_path__ + "static/media/fincantieri_si_modello_231_parte_generale_ita.80b00af7.pdf";